import { z } from 'zod';
import { entityMetaSchema } from '../../utils';

/**
 * Envelope every section subtype shares. Only infrastructure lives here — the
 * subtype's own settings go in `props`, the way grid and tab are laid out.
 *
 * `children` holds column ids in the store and whole column objects while the
 * structure adapter still has the denormalized tree, hence `unknown[]`.
 */
export const sectionBaseSchema = z.object({
    id: z.string(),
    parentId: z.string(),
    children: z.array(z.unknown()),
    entityType: z.literal('section'),
    version: z.number().int().nonnegative(),
    meta: entityMetaSchema,
});
